import { atom } from "recoil";

export const pendingReceiptUpdatedFlagState = atom<boolean>({
  key: "pendingReceiptUpdatedFlagState",
  default: false,
});
